export default __webpack_public_path__ + "static/media/promotion_search_icon.61801faf.svg";